import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetActiveMembersInput } from '../../domain/dtos/get-active-members-input'
import { GetActiveMembersOutput } from '../../domain/dtos/get-active-members-output'
import { GeneralError } from '../../domain/errors/general'
import { Envs } from '../../envs'

export class GetActiveMembers {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: GetActiveMembersInput, signal?: AbortSignal): Promise<GetActiveMembersOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_MEMBERS_AREA_URL}/members/actives/list`,
      params: this.makeParams(input),
      signal,
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data
    }

    throw new GeneralError()
  }

  private makeParams(input: GetActiveMembersInput) {
    const body = {
      page: input.page,
      pageSize: input.pageSize,
      productId: input.productId,
      types: input.types,
      search: input.search,
      orderBy: 'createdAt',
      orderDirection: 'DESC',
    }

    return body
  }
}
